import type { AuthProvider } from "@refinedev/core";

const V = (import.meta as any).env || {};
const API = V?.VITE_API_URL || V?.VITE_API_BASE_URL || "http://localhost:8001";
const USE_MOCK = V?.VITE_USE_MOCK === "true";

// Mock user for development
const MOCK_USER = {
  id: "user-1",
  email: "operator@artvisage.ru",
  name: "Оператор Мария",
  role: "operator",
};

export const authProvider: AuthProvider = {
  login: async ({ email, password }) => {
    // Mock mode: accept any credentials
    if (USE_MOCK) {
      await new Promise((resolve) => setTimeout(resolve, 300)); // Simulate network delay
      localStorage.setItem('token', 'mock-token');
      localStorage.setItem('user', JSON.stringify(MOCK_USER));
      console.log('[AuthProvider] Mock login successful');
      return { success: true, redirectTo: '/' } as any;
    }

    // Real mode: call API
    const form = new URLSearchParams({ email, password });
    const res = await fetch(`${API}/api/v1/auth/login?${form.toString()}`, { method:'POST' });
    if (!res.ok) return { success:false, error:{message:'Login failed', name:'AuthError'}} as any;
    const j = await res.json();
    localStorage.setItem('token', j.access_token);
    localStorage.setItem('user', JSON.stringify(j.user));
    return { success:true, redirectTo:'/' } as any;
  },
  logout: async () => {
    localStorage.removeItem('token'); localStorage.removeItem('user');
    return { success:true, redirectTo:'/login' } as any;
  },
  check: async () => {
    const token = localStorage.getItem('token');
    if (!token) return { authenticated:false, redirectTo:'/login' } as any;
    return { authenticated:true } as any;
  },
  getPermissions: async () => null,
  getIdentity: async () => {
    const u = localStorage.getItem('user');
    return u? JSON.parse(u): null;
  },
  onError: async () => ({}) as any,
};
